import React, { Fragment } from 'react';
import copy from 'copy-to-clipboard';
import BlockLinkScroller from './components/BlockLinkScroller';
import { LinkIcon } from '../../components/Icons';
import makeBlockActionButton from '../utils/makeBlockActionButton';
import { shortenBlockId } from '../../utils/getBlockShortId';
import BlockTypes from '../../types/BlockTypes';
import BlockActionTypes from '../../types/BlockActionTypes';
var LINKABLE_BLOCK = [BlockTypes.UNSTYLED, BlockTypes.OL_LI, BlockTypes.UL_LI, BlockTypes.TODO, BlockTypes.H1, BlockTypes.H2, BlockTypes.H3, BlockTypes.IMAGE, BlockTypes.IMAGE_GALLERY, BlockTypes.EMBED, BlockTypes.EMBED_PLACEHOLDER, BlockTypes.FILE, BlockTypes.QUOTES, BlockTypes.CODES, BlockTypes.TABLE, BlockTypes.HINTS];
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator,
      _ref$getFullNotePath = _ref.getFullNotePath,
      getFullNotePath = _ref$getFullNotePath === void 0 ? function (x) {
    return x;
  } : _ref$getFullNotePath,
      _ref$getNoteId = _ref.getNoteId,
      getNoteId = _ref$getNoteId === void 0 ? function () {} : _ref$getNoteId;

  var Component = decorator(BlockLinkScroller);
  return [{
    renderBlock: function renderBlock(props, editor, next) {
      if (LINKABLE_BLOCK.includes(props.node.type)) {
        var scrollId = editor.getInContinuousBlock(props.node, ['data', 'id']);

        if (scrollId) {
          props.attributes['data-scroll-id'] = shortenBlockId(scrollId);
        }
      }

      return next();
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Fragment, null, next(), React.createElement(Component, {
        editor: editor
      }));
    }
  }, makeBlockActionButton(BlockActionTypes.BLOCK_LINK, {
    index: 1,
    type: BlockActionTypes.ACTION,
    icon: LinkIcon,
    label: 'Copy anchor link',
    canApply: function canApply(editor, store) {
      var node = store.getItem('node');
      return LINKABLE_BLOCK.includes(node.type);
    },
    onClick: function onClick(editor, node) {
      var blockId = editor.getInContinuousBlock(node, ['data', 'id']);
      copy("".concat(getFullNotePath(getNoteId()), "#").concat(shortenBlockId(blockId)));
      editor.command('closeBlockAction').moveFocusToStartOfBlock().command('openToast', {
        title: 'Copied!',
        detail: "Private link has been copied to clipboard"
      });
    }
  })];
});